module.exports = __webpack_public_path__ + "static/img/qiye1@2x.6611318e.png";